import LoadingIndicator, { LoadingIndicatorT } from '@/components/common/LoadingIndicator.tsx'
import { ReactNode, Suspense } from 'react'

type PropsT = {
  children: ReactNode
  className?: string
  type?: LoadingIndicatorT
}

export default function SuspenseWrapper({ children, className, type = 'fullScreen' }: PropsT) {
  return (
    <Suspense fallback={<LoadingIndicator type={type} className={className} />}>
      {children}
    </Suspense>
  )
}
